import { checkResponse, hashCode, myReplacer } from "src/components/js/statics1";
import returnMessageClass from "../system/returnMessageClass";
// eslint-disable-next-line import/no-cycle
import keikkaLaskuRiviClass from "./keikkaLaskuRiviClass";
import { keikkaLaskuRivi_delete, keikkaLaskuRivi_saveToDB } from "./KeikkaLaskuRiviFunctions";

export default class keikkaLaskuClass {
  constructor(keikkaId = null, laskuttajaAsiakasId = null, maksajaAsiakasId = null) {
    this.laskuttajaType = "pumppu"; // pumppu, betoni, lattia
    this.keikkaId = keikkaId;
    this.keikkaLaskuId = null;
    this.keikkaLaskuRivit = [];
    this.sumEur = 0;
    this.memo = null;
    this.header = null;
    this.viitteemme = null;
    this.viitteenne = null;
    this.maksuEhtoPv = 15;
    this.laskuttajaAsiakasId = laskuttajaAsiakasId;
    this.maksajaAsiakasId = maksajaAsiakasId;
    this.maksajaAsiakasNimi = null;
    this.txtBeforeLines = null;
    this.txtAfterLines = null;
    this.keikkaLaskuStatusTypeId = 5; // 1 = Ei laskuteta, 5 = Odottaa, 10 = Valmis, 15 = Laskutettu
    this.keikkaLaskuStatusTypeName = "Initial";
    this.isDeleted = false;
    this.isLoaded = false;
    this.sellerName = null;

    this.laskuLog = []; // keikkaLaskuLogClass
  }

  getSumEur(keikkaLasku) {
    if (!keikkaLasku) keikkaLasku = this;
    let _sum = 0;
    for (let i = 0; i < keikkaLasku.keikkaLaskuRivit.length; i++) {
      const rivi = keikkaLasku.keikkaLaskuRivit[i];
      if (!rivi.aktiivinen) continue;
      if (!rivi.ehtoTäyttyy) continue;
      let value = rivi.hinta * rivi.määrä * (rivi.alennus ? (100 - rivi.alennus) / 100 : 1);
      value = Math.round(value * 100) / 100;
      _sum += value;
    }
    keikkaLasku.sumEur = _sum;
    return _sum;
  }

  getSumEurAlv(keikkaLasku) {
    if (!keikkaLasku) keikkaLasku = this;
    let _sum = 0;
    for (let i = 0; i < keikkaLasku.keikkaLaskuRivit.length; i++) {
      const rivi = keikkaLasku.keikkaLaskuRivit[i];
      let riviEur = 0;
      if (!rivi.aktiivinen) continue;
      if (!rivi.ehtoTäyttyy) continue;
      riviEur = rivi.hinta * rivi.määrä * (rivi.alennus ? (100 - rivi.alennus) / 100 : 1);
      riviEur = Math.round(riviEur * 100) / 100;
      _sum += (riviEur * rivi.alv) / 100;
    }
    return _sum;
  }

  getSumEurWithAlv(keikkaLasku) {
    if (!keikkaLasku) keikkaLasku = this;
    let _sum = 0;
    for (let i = 0; i < keikkaLasku.keikkaLaskuRivit.length; i++) {
      const rivi = keikkaLasku.keikkaLaskuRivit[i];
      let riviEur = 0;
      if (!rivi.aktiivinen) continue;
      if (!rivi.ehtoTäyttyy) continue;
      riviEur = rivi.hinta * rivi.määrä * (rivi.alennus ? (100 - rivi.alennus) / 100 : 1);
      riviEur = Math.round(riviEur * 100) / 100;
      riviEur += (riviEur * rivi.alv) / 100;
      riviEur = Math.round(riviEur * 100) / 100;
      _sum += riviEur;
    }
    return _sum;
  }

  async init(token) {
    try {
      const addr =
        "/api/keikka/laskutus/lasku/get/" +
        this.keikkaId +
        "/" +
        this.laskuttajaAsiakasId +
        "/" +
        this.maksajaAsiakasId;
      const response = await fetch(import.meta.env.VITE_SERVER_URL + addr, {
        method: "GET",
        headers: {
          "x-access-token": `${token}`,
          "Content-Type": "application/json",
        },
      });
      const cResponse = await checkResponse(response, "keikkaLaskuClass:init");
      if (!cResponse.success) return false;
      const result = cResponse.data;

      // save response invoicerows to this object
      if (result.laskuRivit) this._processKeikkaLaskuResponseRivit(result.laskuRivit);
      else console.log("No laskuRivit at keikkaLaskuClass.init()");

      // save response invoicedata to this object
      if (result.laskuData) this._processKeikkaLaskuResponseData(result.laskuData);
      else console.log("No laskuData at keikkaLaskuClass.init()");

      // save response log to this object
      if (result.laskuLog) this.laskuLog = result.laskuLog;
      else console.log("No laskuLog at keikkaLaskuClass.init()");

      // calculate sumEur
      this.sumEur = this.getSumEur();
      this.isLoaded = true;
      return true;
    } catch (error) {
      console.log(error);
      return false;
    }
  }

  _processKeikkaLaskuResponseData(laskuData) {
    const laskuData2 = laskuData.keikkaLaskuId ? laskuData : laskuData[0];
    this.keikkaLaskuId = laskuData2.keikkaLaskuId;
    this.sumEur = laskuData2.sumEur;
    this.header = laskuData2.header;
    this.memo = laskuData2.memo;
    this.viitteemme = laskuData2.viitteemme;
    this.viitteenne = laskuData2.viitteenne;
    this.maksuEhtoPv = laskuData2.maksuEhtoPv;
    this.laskuttajaAsiakasId = laskuData2.laskuttajaAsiakasId;
    this.maksajaAsiakasId = laskuData2.maksajaAsiakasId;
    this.txtBeforeLines = laskuData2.txtBeforeLines;
    this.txtAfterLines = laskuData2.txtAfterLines;
    this.maksajaAsiakasNimi = laskuData2.maksajaAsiakasNimi;
    this.keikkaLaskuStatusTypeId = laskuData2.keikkaLaskuStatusTypeId;
    this.keikkaLaskuStatusTypeName = laskuData2.keikkaLaskuStatusTypeName;
    this.sellerName = laskuData2.sellerName;
  }

  _processKeikkaLaskuResponseRivit(laskuRivit) {
    if (laskuRivit == null || laskuRivit.length == 0) {
      return null;
    }
    //console.log(laskuRivit);

    // process rivit
    const rivit = [];
    let yhteensä = 0;
    for (let i = 0; i < laskuRivit.length; i++) {
      const rivi = laskuRivit[i];
      const keikkaLaskuRivi = new keikkaLaskuRiviClass(this.keikkaId, rivi.keikkaLaskuId);
      keikkaLaskuRivi.keikkaLaskuRiviId = rivi.keikkaLaskuRiviId;
      keikkaLaskuRivi.ehtoKaava = rivi.ehtoKaava;
      keikkaLaskuRivi.ehtoTäyttyy = rivi.ehtoTäyttyy;
      keikkaLaskuRivi.aktiivinen = rivi.aktiivinen;
      keikkaLaskuRivi.riviSelite = rivi.riviSelite;
      keikkaLaskuRivi.riviSeliteKaava = rivi.riviSeliteKaava;
      keikkaLaskuRivi.riviSelite2 = rivi.riviSelite2;
      keikkaLaskuRivi.riviSelite2Kaava = rivi.riviSelite2Kaava;
      keikkaLaskuRivi.memo = rivi.memo;
      keikkaLaskuRivi.määräKaava = rivi.määräKaava;
      keikkaLaskuRivi.määrä = rivi.määrä;
      keikkaLaskuRivi.yksikkö = rivi.yksikkö;
      keikkaLaskuRivi.hintaKaava = rivi.hintaKaava;
      keikkaLaskuRivi.hinta = rivi.hinta;
      keikkaLaskuRivi.sortNum = rivi.sortNum;
      keikkaLaskuRivi.tuoteIdKaava = rivi.tuoteIdKaava;
      keikkaLaskuRivi.tuoteId = rivi.tuoteId;
      keikkaLaskuRivi.helpId = rivi.helpId;
      keikkaLaskuRivi.alv = rivi.alv;
      keikkaLaskuRivi.laskuttajaAsiakasId = rivi.laskuttajaAsiakasId;
      keikkaLaskuRivi.maksajaAsiakasId = rivi.maksajaAsiakasId;
      keikkaLaskuRivi.isLaskutettu = rivi.isLaskutettu;
      keikkaLaskuRivi.laskutettuTime = rivi.laskutettuTime;
      keikkaLaskuRivi.laskuNo = rivi.laskuNo;
      keikkaLaskuRivi.alennus = rivi.alennus;
      keikkaLaskuRivi.kustannusPaikka = rivi.kustannusPaikka;

      // laske hinta
      if (
        keikkaLaskuRivi.ehtoTäyttyy &&
        keikkaLaskuRivi.aktiivinen &&
        keikkaLaskuRivi.hintaKaava &&
        keikkaLaskuRivi.määräKaava
      )
        yhteensä += keikkaLaskuRivi.hinta * keikkaLaskuRivi.määrä;
      rivit.push(keikkaLaskuRivi);
    }

    // sort by laskNo then by sortNum
    rivit.sort((a, b) => {
      if (a.laskuNo > b.laskuNo) return 1;
      if (a.laskuNo < b.laskuNo) return -1;
      if (a.sortNum > b.sortNum) return 1;
      if (a.sortNum < b.sortNum) return -1;
      return 0;
    });

    this.keikkaLaskuRivit = rivit;
    this.sumEur = yhteensä;
    return rivit;
  }

  json() {
    const replacerWrapper = (key, value) => myReplacer(key, value, "lasku");
    return JSON.stringify(this, replacerWrapper, 2);
  }

  async saveKeikkaLaskuToDB(token) {
    try {
      const requestOptions = {
        method: "PUT",
        headers: {
          "Content-Type": "application/json",
          "x-access-token": `${token}`,
        },
        body: this.json(),
      };

      const response = await fetch(
        import.meta.env.VITE_SERVER_URL + "/api/keikka/laskutus/lasku/save",
        requestOptions
      );
      const cResponse = await checkResponse(response, "keikkaLaskuClass:saveKeikkaLaskuToDB");
      return cResponse.success;
    } catch (error) {
      console.log(error);
      return false;
    }
  }

  async evaluateAllRiviKaavat(keikkaData, toimitus) {
    try {
      let sumEur = 0;
      for (let i = 0; i < this.keikkaLaskuRivit.length; i++) {
        const rivi = this.keikkaLaskuRivit[i];
        rivi.evaluateKaavat(keikkaData, toimitus);
        sumEur += rivi.hinta * rivi.määrä;
      }
      this.sumEur = sumEur;
      return true;
    } catch (error) {
      console.log(error);
      return false;
    }
  }

  async evaluateAllKaavat(keikkaData, toimitus, token) {
    try {
      for (let i = 0; i < this.keikkaLaskuRivit.length; i++) {
        const rivi = this.keikkaLaskuRivit[i];
        const originalHash = rivi.hash;
        rivi.evaluateKaavat(keikkaData, toimitus);
        if (originalHash != rivi.hash) {
          await keikkaLaskuRivi_saveToDB(rivi, token);
        } else console.log("No changes to save");
      }
    } catch (error) {
      console.log(error);
    }
  }

  async deleteAllKeikkaLaskurivitFromDB(token) {
    for (let i = 0; i < this.keikkaLaskuRivit.length; i++) {
      const rivi = this.keikkaLaskuRivit[i];
      await keikkaLaskuRivi_delete(this, rivi.keikkaLaskuRiviId, token);
    }
  }

  get isLaskutettu() {
    return this.keikkaLaskuStatusTypeId == 15;
  }

  get uniqueHash() {
    const hash = hashCode(this.json());
    return hash;
  }
}

export async function keikkaLasku_importFromPumiFi(keikkaData, token) {
  const keikkaId = keikkaData.keikkaId;
  try {
    const requestOptions = {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        "x-access-token": `${token}`,
      },
    };
    const response = await fetch(
      import.meta.env.VITE_SERVER_URL +
        "/api/pumi.fi/syncBetoniOnlineProductsFromPumiFi/" +
        keikkaId,
      requestOptions
    );
    const cResponse = await checkResponse(response, "keikkaLaskuClass:syncLaskuDataFromPumiFi");
    return cResponse;
  } catch (error) {
    console.log(error);
    return error;
  }
}

export async function keikkaLasku_exportToNetvisor(
  keikkaLasku,
  isProduction,
  token,
  uploadPumiFiAttachments = false
) {
  const keikkaId = keikkaLasku.keikkaId;
  const laskuttajaAsiakasId = keikkaLasku.laskuttajaAsiakasId;
  const maksajaAsiakasId = keikkaLasku.maksajaAsiakasId;
  try {
    const requestOptions = {
      method: "PUT",
      headers: {
        "Content-Type": "application/json",
        "x-access-token": `${token}`,
      },
      body: JSON.stringify({
        keikkaId: keikkaId,
        laskuttajaAsiakasId: laskuttajaAsiakasId,
        maksajaAsiakasId: maksajaAsiakasId,
        isProduction: isProduction,
        uploadPumiFiAttachments: uploadPumiFiAttachments,
      }),
    };
    const response = await fetch(
      import.meta.env.VITE_SERVER_URL + "/api/keikka/laskutus/createNetvisorLasku",
      requestOptions
    );
    const cResponse = await checkResponse(response, "keikkaLaskuClass:createNetvisorLasku");
    if (!cResponse.success) return false;
    const result = cResponse.data;
    return result;
    // example result:
    // {
    //   "success": true,
    //   "message": "Netvisor lasku numero 12345 luotu",
    // }
  } catch (error) {
    console.log(error);
    return {
      success: false,
      message:
        "keikkaLaskuClass.createNetvisorLasku() fetch failed. Cannot access server or no internet connection.",
    };
  }
}

export function keikkaLaskuStatusType_getName(keikkaLaskuStatusTypeId) {
  switch (keikkaLaskuStatusTypeId) {
    case 1:
      return "Ei laskuteta";
    case 5:
      return "Odottaa";
    case 10:
      return "Valmis";
    case 13:
      return "Käänteinen laskutus";
    case 15:
      return "Laskutettu";
    default:
      return "Unknown";
  }
}
export async function keikkaLaskuRivit_copy(
  sourceKeikkaLaskuId,
  targetKeikkaLaskuId,
  targetKeikkaData,
  targetToimitus,
  token,
  laskuttajaAsiakasId,
  maksajaAsiakasId
) {
  let returnMessage = new returnMessageClass("keikkaLaskuClass.copyKeikkaLaskuRivit()");
  try {
    const requestOptions = {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "x-access-token": `${token}`,
      },
      body: JSON.stringify({
        sourceKeikkaLaskuId: sourceKeikkaLaskuId,
        targetKeikkaLaskuId: targetKeikkaLaskuId,
      }),
    };
    const response = await fetch(
      import.meta.env.VITE_SERVER_URL + "/api/keikka/laskutus/laskuRivit/copy",
      requestOptions
    );
    const success = (await checkResponse(response, "keikkaLaskuClass:copyKeikkaLaskuRivit"))
      .success;
    console.log("Start evaluating kaavat");
    if (success) {
      const _keikkaLaskuClass = new keikkaLaskuClass(
        targetKeikkaData.keikkaId,
        laskuttajaAsiakasId,
        maksajaAsiakasId
      );
      await _keikkaLaskuClass.init(token);
      await _keikkaLaskuClass.evaluateAllKaavat(targetKeikkaData, targetToimitus, token);
    }
    returnMessage.success = success;
    returnMessage.message = "Rivit kopioitu";
    return returnMessage;
  } catch (error) {
    console.log(error);
    returnMessage.message = "Rivien kopioiminen epäonnistui";
    returnMessage.error = error;
    return returnMessage;
  }
}
